module.exports = __webpack_public_path__ + "img/8.a3c7a8a0.jpg";